import React, { createContext, useContext, useMemo, useState } from 'react';

const SidebarMenuContext = createContext(null);

export function SidebarMenuProvider({ children }) {
  const [openKeys, setOpenKeys] = useState([]);

  const value = useMemo(
    () => ({
      openKeys,
      setOpenKeys,
    }),
    [openKeys]
  );

  return <SidebarMenuContext.Provider value={value}>{children}</SidebarMenuContext.Provider>;
}

export function useSidebarMenuContext() {
  const context = useContext(SidebarMenuContext);

  if (!context) {
    throw new Error('useSidebarMenuContext must be used within SidebarMenuProvider');
  }

  return context;
}
